import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.scss";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
